// Translation: Model > Phone number verifier > Phone verification dialog (Arabic)
export default Object.freeze({
	actions: {
		cancel: '',
		resend: '',
		send: ''
	},
	input: {
		placeholder: ''
	},
	title: ''
})
